export default "/2CRV.9730f8dbe7705e93ac02b258a7b44b47.png";